"use client";

import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";

const TotalProfit = ({ data }) => {
  const [Chart, setChart] = useState();

  useEffect(() => {
    import("react-apexcharts").then((mod) => {
      setChart(() => mod.default);
    });
  }, []);

  // ✅ TEMP chart
  const series = [
    {
      name: "Idle %",
      data: [5, 8, 6, 10, 7, 9, 6],
    },
  ];

  const options = {
    chart: {
      zoom: { enabled: false },
      toolbar: { show: false },
    },
    colors: ["#3584FC"],
    dataLabels: { enabled: false },
    grid: { show: false },
    stroke: { curve: "straight", width: 2 },
    xaxis: {
      categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      labels: { show: false },
    },
    yaxis: { show: false },
  };

  // ✅ Calculate Idle %
  const total = data?.today_total || 0;
  const idle = data?.today_idle || 0;

  const idlePercent =
    total > 0 ? Math.round((idle / total) * 100) : 0;

  // ✅ Comparison
  const change = data?.change_week || 0;
  const isUp = change >= 0;

  return (
    <Card className="border bg-white rounded-3 overflow-hidden mb-4">
      
      {/* Top */}
      <div className="d-flex align-items-center p-4 pb-3 mb-1">
        <div className="flex-shrink-0">
          <div
            className="wh-55 bg-card-bg-c bg-opacity-25 text-center rounded-2"
            style={{ lineHeight: "55px" }}
          >
            <i className="ri-pause-circle-line fs-22 bg-card-bg-c text-white rounded-2 p-2"></i>
          </div>
        </div>

        <div className="flex-grow-1 ms-3">
          <h3 className="fs-24 fw-medium mb-0">
            {data ? `${idlePercent}%` : "--"}
          </h3>
          <span>Idle Time %</span>
        </div>
      </div>

      {/* Change */}
      <div className="d-flex align-items-center p-4 pb-0">
        <span
          className={`d-inline-block ${
            isUp
              ? "bg-success text-success border-success"
              : "bg-danger text-danger border-danger"
          } bg-opacity-10 border rounded-pill px-2 fw-medium d-flex align-items-center fs-12`}
        >
          <i className={`ri-arrow-${isUp ? "up" : "down"}-fill fs-14 lh-1`}></i>
          {Math.abs(change)}%
        </span>

        <span className="ms-2 fs-12">from last week</span>
      </div>

      {/* Chart */}
      <div style={{ margin: "-45px -11px -31px -15px" }}>
        {Chart && (
          <Chart
            options={options}
            series={series}
            type="area"
            height={120}
          />
        )}
      </div>
    </Card>
  );
};

export default TotalProfit;